var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconModalUserActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 128,
    viewBox: "0 0 239 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3224_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.647 19.5738L112.367 19.2436C112.443 19.1759 120.071 12.8262 131.102 9.6091C141.287 6.62901 156.551 5.79086 171.357 18.6764L171.078 18.9981C156.415 6.23957 141.32 7.06925 131.238 10.0155C120.3 13.2072 112.723 19.5061 112.647 19.5738Z",
    fill: "#E3E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.331 101.89C228.74 84.9326 222.17 72.064 205.137 62.6242C200.117 59.8389 193.827 58.4758 190.813 53.5908C187.824 48.7397 188.933 42.534 188.341 36.8617C186.817 22.3084 172.916 11.0653 158.371 9.52444C143.827 7.9836 129.35 14.5703 118.303 24.1624C110.014 31.3587 102.751 40.536 92.3038 43.9055C75.0758 49.4594 56.3323 37.0734 38.6556 40.9509C29.1484 43.0335 21.1651 49.6964 15.3406 57.5022C5.58791 70.557 3.15821 87.0745 6.13819 103.093C7.7721 111.855 11.7595 120.744 17.4825 127.56L222.45 127.128C228.443 121.142 231.009 109.154 230.331 101.89Z",
    fill: "#E3E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4734 36.5315C92.2214 36.5315 99.3131 29.4396 99.3131 20.6913C99.3131 11.943 92.2214 4.8511 83.4734 4.8511C74.7254 4.8511 67.6338 11.943 67.6338 20.6913C67.6338 29.4396 74.7254 36.5315 83.4734 36.5315Z",
    fill: "#E3E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.507 11.2029C117.069 8.64061 117.069 4.48628 114.507 1.92396C111.945 -0.63835 107.79 -0.638349 105.228 1.92396C102.666 4.48628 102.666 8.64061 105.228 11.2029C107.79 13.7652 111.945 13.7652 114.507 11.2029Z",
    fill: "#E3E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.953 57.0078C217.515 54.4455 217.515 50.2911 214.953 47.7288C212.391 45.1665 208.237 45.1665 205.674 47.7288C203.112 50.2911 203.112 54.4455 205.674 57.0078C208.237 59.5701 212.391 59.5701 214.953 57.0078Z",
    fill: "#E3E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.349 127.382L228.968 127.179C236.664 112.668 237.485 97.0646 231.203 84.3738C224.6 71.0312 211.131 62.057 193.268 59.1023L193.335 58.679C211.334 61.6591 224.921 70.7179 231.584 84.1791C237.925 96.9969 237.112 112.744 229.349 127.382Z",
    fill: "#E3E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6842 128C9.41411 118.01 3.29329 105.979 0.990574 93.2125C-1.15129 81.326 0.228646 69.5242 4.89334 59.9913C12.0893 45.2686 26.0242 37.6745 43.1167 39.173L43.0829 39.5963C26.1765 38.1232 12.3941 45.6242 5.2743 60.1775C0.651939 69.6258 -0.719532 81.3345 1.4054 93.1363C3.69119 105.827 9.77815 117.781 18.9975 127.704L18.6842 128Z",
    fill: "#E3E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.438 62.7513H68.4551V127.534H159.438V62.7513Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.293 39.8503H151.463V24.4842C151.463 21.3855 153.977 18.8711 157.076 18.8711C158.625 18.8711 160.03 19.4976 161.046 20.5135C162.045 21.5125 162.68 22.901 162.689 24.4334V24.4842L162.68 34.2372C162.68 34.288 162.68 34.3388 162.689 34.3811V34.6774L162.706 34.669C162.926 37.5729 165.338 39.8503 168.293 39.8503Z",
    fill: "#D7E1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.906 30.8507V34.2457C173.906 35.795 173.279 37.2003 172.263 38.2078C171.256 39.2238 169.851 39.8503 168.301 39.8503C165.347 39.8503 162.926 37.5729 162.714 34.669L173.906 30.8507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.076 18.8711C156.957 18.8711 156.839 18.8796 156.729 18.888C156.653 18.8965 156.576 18.8965 156.509 18.905C156.424 18.9134 156.348 18.9219 156.272 18.9388C156.221 18.9473 156.178 18.9558 156.128 18.9642C156.068 18.9727 156.009 18.9896 155.95 18.9981C155.865 19.015 155.781 19.032 155.696 19.0574C155.577 19.0912 155.459 19.1251 155.34 19.1674C155.281 19.1843 155.222 19.2097 155.163 19.2267C155.103 19.2436 155.044 19.269 154.993 19.2944C154.909 19.3283 154.832 19.3621 154.756 19.396C154.689 19.4299 154.621 19.4553 154.553 19.4976C154.536 19.5061 154.511 19.5145 154.494 19.5315C154.435 19.5653 154.375 19.5992 154.316 19.633C154.079 19.7685 153.85 19.9124 153.647 20.0818C153.588 20.1326 153.52 20.1833 153.469 20.2257C153.402 20.2849 153.342 20.3357 153.275 20.395C153.207 20.4543 153.148 20.5135 153.088 20.5728C152.919 20.7421 152.767 20.9199 152.614 21.1146C152.547 21.1993 152.487 21.284 152.428 21.3686C152.242 21.6565 152.081 21.9528 151.937 22.2745C151.903 22.3507 151.869 22.4354 151.836 22.5115C151.742 22.7571 151.666 23.011 151.607 23.265C151.59 23.3582 151.573 23.4428 151.556 23.5275C151.522 23.7053 151.497 23.8831 151.488 24.0609V102.779H76.4639V27.6251C76.4639 22.7909 80.3836 18.8796 85.2091 18.8796H157.076V18.8711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.26 26.897H85.3271V29.894H142.26V26.897Z",
    fill: "#E0E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.849 35.6764H85.3271V38.6735H137.849V35.6764Z",
    fill: "#E0E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.081 44.4474H85.3271V47.4444H135.081V44.4474Z",
    fill: "#E0E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.26 53.2268H85.3271V56.2238H142.26V53.2268Z",
    fill: "#E0E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.197 62.1078H107.33V65.1048H138.197V62.1078Z",
    fill: "#E0E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.544 78.9301C113.206 78.9301 112.893 78.8116 112.672 78.5153C112.41 78.1512 112.427 77.6517 112.435 77.3215L112.723 69.575L113.155 69.5919L112.867 77.3385C112.85 77.7025 112.859 78.0412 113.02 78.2697C113.384 78.7692 114.256 78.3375 114.433 78.2443C115.297 77.7787 115.915 76.9152 116.516 76.0685C117.185 75.1373 117.871 74.1636 118.912 73.7149C119.53 73.444 119.987 73.8419 120.351 74.1552C120.554 74.333 120.757 74.5023 120.961 74.5616C121.502 74.7224 122.044 74.5785 122.62 74.4346C123.128 74.2991 123.653 74.1636 124.195 74.2483C124.686 74.3245 125.083 74.5192 125.473 74.7139C126.04 74.9933 126.531 75.2388 127.242 75.0611C128.224 74.824 129.13 74.2652 130.011 73.7234C130.265 73.571 130.519 73.4102 130.781 73.2578C131.771 72.6821 133.261 71.954 134.743 72.2926L134.65 72.7075C133.312 72.4027 131.932 73.08 131.001 73.6218C130.747 73.7657 130.493 73.9266 130.239 74.079C129.333 74.6378 128.394 75.2135 127.344 75.4674C126.48 75.6706 125.871 75.3743 125.278 75.0865C124.923 74.9087 124.559 74.7309 124.127 74.6632C123.678 74.5954 123.212 74.7139 122.73 74.8409C122.129 75.0018 121.502 75.1627 120.842 74.9679C120.546 74.8833 120.309 74.6716 120.072 74.4684C119.691 74.1382 119.437 73.9435 119.09 74.0959C118.158 74.5023 117.532 75.3828 116.872 76.3056C116.245 77.1861 115.593 78.1004 114.645 78.6084C114.298 78.8031 113.9 78.9301 113.544 78.9301Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M151.488 65.4689V102.771H76.4639V62.2179L99.8974 81.7155C101.193 82.7907 102.886 83.2055 104.554 82.9684C105.036 82.9007 105.536 82.8753 106.027 82.8838L122.002 83.3325C122.552 83.3494 123.102 83.4172 123.636 83.5357C125.295 83.8913 127.022 83.5695 128.394 82.5536L151.488 65.4689Z",
    fill: "#D7E1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.666 89.6059L102.04 90.3002L73.8058 121.608L68.4639 127.534V62.7513L102.666 89.6059Z",
    fill: "url(#paint0_linear_3224_234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.438 62.7513L125.228 89.6059L159.438 127.534V62.7513Z",
    fill: "url(#paint1_linear_3224_234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.039 90.3002L73.8055 121.608L68.4551 122.785V111.271C82.5677 101.154 98.3989 89.4281 102.022 89.1742L102.039 90.3002Z",
    fill: "#17468C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.854 90.3002L154.087 121.608L159.438 122.785V111.271C145.325 101.154 129.494 89.4281 125.87 89.1742L125.854 90.3002Z",
    fill: "#17468C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.438 127.534H68.4551L68.472 119.009L99.8211 90.5711C101.464 89.081 103.605 88.2513 105.832 88.2513H121.815C124 88.2513 126.116 89.0556 127.75 90.5033L159.522 118.713L159.438 127.534Z",
    fill: "url(#paint2_linear_3224_234)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M164.444 122.962C170.547 116.859 170.547 106.964 164.444 100.86C158.341 94.7571 148.446 94.7571 142.343 100.86C136.239 106.964 136.239 116.859 142.343 122.962C148.446 129.065 158.341 129.065 164.444 122.962Z",
    fill: "#5B4DAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.151 122.963C175.254 116.86 175.254 106.965 169.151 100.861C163.048 94.7582 153.153 94.7582 147.05 100.862C140.947 106.965 140.947 116.86 147.05 122.963C153.153 129.067 163.048 129.067 169.151 122.963Z",
    fill: "url(#paint3_linear_3224_234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.761 120.38C157.016 120.38 156.304 120.067 155.796 119.508L150.268 113.404C149.794 112.879 149.828 112.067 150.361 111.593C150.886 111.118 151.699 111.152 152.173 111.686L157.701 117.79C157.71 117.798 157.735 117.824 157.777 117.815C157.82 117.807 157.837 117.781 157.837 117.764L163.788 104.219C164.076 103.567 164.83 103.27 165.481 103.558C166.133 103.846 166.43 104.599 166.142 105.251L160.19 118.797C159.826 119.627 159.081 120.203 158.192 120.347C158.048 120.364 157.904 120.38 157.761 120.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239 127.348H1.43066V127.78H239V127.348Z",
    fill: "#102048"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3224_234",
    x1: 102.666,
    y1: 95.1428,
    x2: 66.9718,
    y2: 95.1428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17468C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3224_234",
    x1: 159.438,
    y1: 95.1428,
    x2: 123.735,
    y2: 95.1428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17468C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3224_234",
    x1: 159.522,
    y1: 107.893,
    x2: 64.4823,
    y2: 107.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17468C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E9F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3224_234",
    x1: 137.073,
    y1: 110.838,
    x2: 173.409,
    y2: 95.6558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD2BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#28C0BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2095AA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3224_234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 239,
    height: 128,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModalUserActive);
export default __webpack_public_path__ + "static/media/icon_modal_user_active.40ccbd004d62c51209a841fb69994fa8.svg";
export { ForwardRef as ReactComponent };